import { BaseProvider } from '@ethersproject/providers'
import { BigNumber, BigNumberish, Contract, ContractTransaction } from 'ethers'

import { config } from 'configs'
import useContract from './useContract'
import { Gladiator as AbiGladiator } from '../abi'

interface GladiatorContract extends Contract {
  readonly play: (
    choice: BigNumberish,
    settings: { value: BigNumberish; gasLimit?: BigNumberish }
  ) => Promise<ContractTransaction>

  readonly claim: (settings?: {
    gasLimit?: BigNumberish
  }) => Promise<ContractTransaction>

  readonly infoOf: (account: string) => Promise<{
    total: BigNumber
    claimable: BigNumber
    lastseen: number | BigNumber
    weekPlayed: BigNumber
  }>

  readonly weekChampions: (rank: 0 | 1 | 2) => Promise<string>
  readonly championRatio: (rank: 0 | 1 | 2) => Promise<BigNumber>
}

export default function useGladiator(provider: BaseProvider) {
  return useContract(
    provider,
    config('contract.Gladiator'),
    AbiGladiator
  ) as GladiatorContract | null
}
